import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";

const COLS = [
  { h: "Marketplace", links: [["/browse", "Browse cars"], ["/sell", "Sell my car"], ["/pricing", "Pricing"]] },
  { h: "Legal", links: [["/legal/terms", "Terms of use"], ["/legal/privacy", "Privacy"], ["/legal/liability", "Platform liability"]] },
];

export function Footer() {
  return (
    <footer className="bg-navy text-white/70 mt-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 py-16 grid grid-cols-2 md:grid-cols-4 gap-10">
        <div className="col-span-2">
          <div className="[&_a]:text-white"><Logo light testId="footer-logo" /></div>
          <p className="text-sm mt-4 max-w-sm">The UK marketplace where sellers keep every pound of the sale. One flat fee, no commission.</p>
          <p className="text-xs mt-6 max-w-sm text-white/50">Vorra is a marketplace intermediary and is not a party to any vehicle sale. Sellers are solely responsible for vehicle condition, description accuracy and the sale itself.</p>
        </div>
        {COLS.map((c) => (
          <div key={c.h}>
            <h4 className="font-heading font-semibold text-sm text-white mb-4">{c.h}</h4>
            <ul className="space-y-2.5 text-sm">
              {c.links.map(([to, label]) => <li key={to}><Link to={to} className="hover:text-white transition-colors">{label}</Link></li>)}
            </ul>
          </div>
        ))}
      </div>
      <div className="border-t border-white/10 py-6 text-center text-xs text-white/40">
        © {new Date().getFullYear()} Vorra. A marketplace platform, not a party to any vehicle sale.
      </div>
    </footer>
  );
}
